import React, { useContext } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../../shared/Button';
import AuthContext from '../../../context/AuthContext';

const StyledForm = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 80vw;
  width: 700px;
  a {
    color: white;
    text-decoration: none;
    &:hover,
    &:focus {
      color: #eee;
      text-decoration: underline;
    }
  }

  form {
    display: flex;
    flex-direction: column;
  }
  input {
    font-size: 18px;
    margin-top: 20px;
    display: block;
    padding: 15px;
    border-radius: 20px;
    background: none;
    border: 2px solid white;
    outline: none;
    color: white;

    &::placeholder {
      color: white;
      font-family: 'gothammedium';
      font-weight: 300;
    }
  }
  textarea {
    width: 90%;
    font-size: 18px;
    margin-top: 20px;
    height: 200px;
    display: block;
    padding: 15px;
    border-radius: 20px;
    background: none;
    border: 2px solid white;
    outline: none;
    color: white;

    &::placeholder {
      color: white;
      font-family: 'gothammedium';
      font-weight: 300;
    }
  }
  span {
    display: block;
    margin-left: 20px;
    margin-top: 10px;
  }
  button {
    margin-top: 20px;
    align-self: center;
  }
`;

const SignInSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
  password: Yup.string().required('Required'),
});

const SignIn = () => {
  const { signIn } = useContext(AuthContext);
  const handleSignIn = ({ email, password }) => {
    signIn(email, password);
  };

  return (
    <StyledForm>
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        validationSchema={SignInSchema}
        onSubmit={handleSignIn}
      >
        {({ errors, touched }) => (
          <Form>
            <Field id="email" name="email" type="email" placeholder="Email" />
            {errors.email && touched.email ? <span>{errors.email}</span> : null}
            <Field
              id="password"
              name="password"
              type="password"
              placeholder="Password"
            />
            {errors.password && touched.password ? (
              <span>{errors.password}</span>
            ) : null}

            <Button type="submit">Sign In</Button>
          </Form>
        )}
      </Formik>
      <Link to="passwordReset">Forgot Password?</Link>
    </StyledForm>
  );
};

export default SignIn;
